var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideomailWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.512 20L17.178 5.35201C15.773 2.88201 12.227 2.88201 10.822 5.35201L2.48801 20C1.09301 22.451 2.85501 25.5 5.66601 25.5H22.334C25.145 25.5 26.907 22.451 25.512 20ZM13 9.49901C13 8.94701 13.448 8.49901 14 8.49901C14.552 8.49901 15 8.94601 15 9.49901V16.5C15 17.052 14.552 17.5 14 17.5C13.448 17.5 13 17.053 13 16.5V9.49901ZM12.5 21C12.5 21.828 13.172 22.5 14 22.5C14.828 22.5 15.5 21.828 15.5 21C15.5 20.172 14.828 19.5 14 19.5C13.172 19.5 12.5 20.172 12.5 21Z",
    fill: "#DF352C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideomailWarning);
export default __webpack_public_path__ + "static/media/VideomailWarning.6335d01a9800418b9607812cbd2f68fa.svg";
export { ForwardRef as ReactComponent };